export function isAdminV2ValidHttpUrl(value: string) {
  const trimmed = value.trim();
  if (trimmed !== value || trimmed.length === 0) {
    return false;
  }

  for (const character of value) {
    const codePoint = character.charCodeAt(0);
    if (/\s/.test(character) || codePoint <= 31 || codePoint === 127) {
      return false;
    }
  }

  try {
    const url = new URL(value);
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      url.hostname.trim().length > 0
    );
  } catch {
    return false;
  }
}
